import {types, flow} from 'mobx-state-tree';
import {RouterModel} from 'mst-react-router';
import AuthStore from './AuthStore';
import UserStore from './UserStore';
import TransactionsStore from './TransactionsStore';
import * as api from '../lib/api';

const App = types
  .model('App', {
    loading: true,
    user: types.maybe(UserStore),
    auth: types.optional(AuthStore, {}),
    transactions: types.optional(TransactionsStore, {items: []}),
    router: RouterModel
  })
  .actions((self) => {
    const afterAuth = flow(function* () {
      try {
        self.user = yield api.fetchUser();
        yield self.user.updateBalance();
        self.transactions.fetch();
        self.router.push('/');
      } catch (error) {
        self.auth.logout();
      }
    });
    const afterLogout = () => {
      self.user = undefined;
      self.transactions = {items: []};
      self.router.push('/auth/login');
    };
    const afterCreate = flow(function* () {
      if (self.auth.authenticated) {
        yield afterAuth();
      }
      self.loading = false;
    });
    return {afterCreate, afterAuth, afterLogout};
  });

export default App;
